<template>
  <div class="wl-results" v-if="doc">
    <results-summary :id="doc.id"></results-summary>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { ResultsSummary } from "@/components/results/groups";

export default {
  name: "Groupresults",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null,
    };
  },
  components: {
    ResultsSummary,
  },
  computed: {
    ...mapState(["exGroups"]),
  },
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
      this.summary = true;
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.summary = false;
    },
  },
};
</script>
